import { differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns'
import { useCallback, useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { SectionDetailProduct } from '../../@types/home'
import { getSectionsDetailKeywordVer1, getSectionsDetailSale } from '../../api/home'
import ProductHeader from '../../components/festival/ProductHeader'
import ProductItem from '../../components/festival/ProductItem'
import ProductListItem from '../../components/festival/ProductListItem'
import ProductSortModal from '../../components/festival/ProductSortModal'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductFilterCenterModal from '../../components/product/ProductFilterCenterModal'
import ProductFilterModal from '../../components/product/ProductFilterModal'
import ProductModal from '../../components/product/ProductModal'
import '../../css/home.css'
import '../../css/Product.css'
import CategoryManyProduct from '../../pages/festivals/CategoryManyProduct'
import { imgURL } from '../Footer'

// 이미지 경로

export default function HotDealList() {
  const [sectionItem, setSectionItem] = useState<SectionDetailProduct[]>([])
  const [listItem, setListItem] = useState<any>([]) //상품 아이템
  const [totalCount, setTotalCount] = useState<string>('') //상품 리스트 개수
  const [twoDepCategory, setTwodepCategory] = useState<any>([])
  const [isModal, setIsModal] = useState(false)
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [type, setType] = useState<string>('thumb')
  const [sortKeyword, setSortKeyword] = useState<string>('RECOMMENDATION') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('추천순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isSort, setIsSort] = useState<boolean>(false) //정렬 팝업열기
  const [isFilter, setIsFilter] = useState<boolean>(false) //필터 팝업열기
  const [getMax, setGetMax] = useState<number>(1000000)
  const [getMin, setGetMin] = useState<number>(0)
  const [freeCheck, setFreeCheck] = useState<boolean>(false)
  const [filterApply, setFilterApply] = useState<boolean>(false)
  const [brandArray, setBrandArray] = useState<any>([])
  const [filterTotal, setFilterTotal] = useState(0)
  const [filterMin, setFilterMin] = useState(0)
  const [filterMax, setFilterMax] = useState(1000000)
  const [one, setOne] = useState<any>()
  const [max, setMax] = useState<number>(1000000)
  const [min, setMin] = useState<number>(0)
  const [thirdDepLabel, setThirdDepLabel] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [sectionDetails, setSectionDetails] = useState<SectionDetailProduct[]>([]) //카테고리섹션 정렬
  const [categorySectionNo, setCategorySectionNo] = useState<any>() //선택된 카테고리 번호
  const [categoryLike, setCategoryLike] = useState<boolean>(false) // 카테고리 좋아요

  const obsRef = useRef(null) //observer Element
  const [page, setPage] = useState(1) //현재 페이지
  const listItemRef = useRef<any>(null)

  const location = useLocation()

  const [time, setTime] = useState('')
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  const calculateTimeLeft = useCallback(() => {
    const targetDate = new Date(time)
    const now = new Date()

    if (targetDate > now) {
      const hours = differenceInHours(targetDate, now)
      const minutes = differenceInMinutes(targetDate, now) % 60
      const seconds = differenceInSeconds(targetDate, now) % 60

      setTimeLeft({ hours, minutes, seconds })
    } else {
      setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
    }
  }, [time])

  useEffect(() => {
    if (time) {
      calculateTimeLeft()
      const intervalId = setInterval(calculateTimeLeft, 1000)
      return () => clearInterval(intervalId)
    }
  }, [calculateTimeLeft, time])

  const formatTwoDigits = (num: number) => {
    return num.toString().padStart(2, '0')
  }

  useEffect(() => {
    if (sectionItem?.length > 0) {
      setTime(sectionItem[0].sectionProductEndYmdt)
    }
  }, [sectionItem])

  useEffect(() => {
    if (location.state) {
      setCategorySectionNo(location.state.sectionNo)
    }
  }, [location.state])

  //상품진열관리 상세 조회
  useEffect(() => {
    if (categorySectionNo) {
      const array: any = []
      getSectionsDetailKeywordVer1(Number(categorySectionNo), sortKeyword).then((res) => {
        setSectionDetails(res.data.products)
        setSectionItem(res.data.products)
      })
    }
  }, [categorySectionNo, categoryLike, sortKeyword])

  //카테고리용 상세조회

  useEffect(() => {
    setTimeout(() => {
      setLoading(true)
    }, 300)
  }, [])

  const headerImg = {
    mobileUrl: `${imgURL}/img_hotdeal_list_mobile.png`,
    pcUrl: `${imgURL}/img_hotdeal_list_pc.png`,
  }

  return (
    <>
      <div className='main_wrap'>
        <div className='hot_deal_cont'>
          {/* 상단이미지 */}
          <div className='visual_img'>
            <img src={isMobile ? headerImg.mobileUrl : headerImg.pcUrl} alt='핫딜 상세 상단 이미지' />
            {/* 핫딜 시간 */}
            <div className='hot_deal'>
              <div className='hot_deal_title list'>
                <div className='time'>
                  {` ${formatTwoDigits(timeLeft.hours)}:${formatTwoDigits(timeLeft.minutes)}:${formatTwoDigits(
                    timeLeft.seconds
                  )}`}{' '}
                  <span>남음</span>
                </div>
              </div>
            </div>
          </div>

          {/* 카테고리 */}
          <CategoryManyProduct />
          {/* 카테고리 4dept */}
          {/* 상품 목록 전체 wrap */}
          <div className={'product_list_wrap product'}>
            {/* 상품목록 header */}
            <ProductHeader
              totalCount={sectionDetails.length}
              type={type}
              setSortDirection={setSortDirection}
              sortDirection={sortDirection}
              setSortKeywordLabel={setSortKeywordLabel}
              setType={setType}
              isSort={isSort}
              setIsSort={setIsSort}
              sortKeyword={sortKeyword}
              setSortKeyword={setSortKeyword}
              sortKeywordLabel={sortKeywordLabel}
              setIsFilter={setIsFilter}
              filterTotal={filterTotal}
            ></ProductHeader>

            {/* 상품 Item Wrap */}

            {sectionDetails.length !== 0 && loading ? (
              <>
                <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'} ref={listItemRef}>
                  {type === 'thumb' &&
                    sectionDetails.map((el: any, idx: number) => {
                      return (
                        <ProductItem
                          item={el}
                          key={el.productNo}
                          setIsModal={setIsModal}
                          setSelectProductNo={setSelectProductNo}
                          page={page}
                          listItem={listItem}
                          one={one}
                          twoDepCategory={twoDepCategory}
                          thirdDepLabel={thirdDepLabel}
                          idx={idx}
                          totalCount={Number(totalCount)}
                        />
                      )
                    })}
                  {type === 'list' &&
                    sectionDetails.map((el: any, idx: number) => {
                      return (
                        <ProductListItem
                          item={el}
                          listItem={listItem}
                          idx={idx}
                          key={el.productNo}
                          setIsModal={setIsModal}
                          setSelectProductNo={setSelectProductNo}
                          page={page}
                          one={one}
                          twoDepCategory={twoDepCategory}
                          thirdDepLabel={thirdDepLabel}
                        />
                      )
                    })}
                </div>
              </>
            ) : (
              <div className='product_list_wrap empty'>
                <div className='no_data'>
                  <img src={`${imgURL}/empty_logo.png`} alt='' />
                  <p>상품이 없습니다.</p>
                </div>
              </div>
            )}
          </div>
          {isMobile && isSort && (
            <ProductSortModal
              headerText='정렬'
              setIsModal={setIsSort}
              setSortKeyword={setSortKeyword}
              sortKeyword={sortKeyword}
              setSortKeywordLabel={setSortKeywordLabel}
              setSortDirection={setSortDirection}
              sortDirection={sortDirection}
            ></ProductSortModal>
          )}
          {isModal &&
            (isMobile ? (
              <ProductModal
                setIsModal={setIsModal}
                listItem={sectionDetails}
                headerText={'옵션선택'}
                selectProductNo={selectProductNo}
              ></ProductModal>
            ) : (
              <ProductCenterModal
                setIsModal={setIsModal}
                headerText={'옵션선택'}
                selectProductNo={selectProductNo}
                listItem={sectionDetails}
              ></ProductCenterModal>
            ))}
          {isFilter &&
            (isMobile ? (
              <ProductFilterModal
                isCategoryModal={isFilter}
                setIsCategoryModal={setIsFilter}
                setFreeCheck={setFreeCheck}
                setGetMax={setGetMax}
                setGetMin={setGetMin}
                setFilterApply={setFilterApply}
                setBrandArray={setBrandArray}
                brandArray={brandArray}
                freeCheck={freeCheck}
                max={max}
                filterMax={filterMax}
                setMax={setMax}
                min={min}
                filterMin={filterMin}
                setMin={setMin}
              ></ProductFilterModal>
            ) : (
              <ProductFilterCenterModal
                isCategoryModal={isFilter}
                setIsCategoryModal={setIsFilter}
                setFreeCheck={setFreeCheck}
                setGetMax={setGetMax}
                setGetMin={setGetMin}
                setFilterApply={setFilterApply}
                setBrandArray={setBrandArray}
                brandArray={brandArray}
                freeCheck={freeCheck}
                max={max}
                filterMax={filterMax}
                setMax={setMax}
                min={min}
                filterMin={filterMin}
                setMin={setMin}
              ></ProductFilterCenterModal>
            ))}
        </div>
        <div ref={obsRef}></div>
        {/* <div ref={obsRef} style={{ height: "20px" }}></div> */}
      </div>
    </>
  )
}
// 상품목록 헤더영역 wrap
export const ProductListHeder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  @media screen and (min-width: 768px) {
    padding: 14px 0;
  }
`

export const ProductListNum = styled.div`
  color: var(--colGray6);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  & span {
    color: var(--colBlack);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
`

// 상품목록 헤더옵션(정렬, 필터, 상품목록 보기정렬 버튼)
export const ProductListOption = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & li {
    position: relative;
    & img {
    }
    @media screen and (min-width: 768px) {
      &:first-of-type {
      }
      &:nth-of-type(2) {
      }
      &:last-of-type {
      }
    }
    & .sort_layer {
      @media screen and (min-width: 768px) {
        position: absolute;
        top: 32px;
        right: 0;
        min-width: 135px;
        border-radius: 8px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
        background: var(--colWhite);
        z-index: 10;
        & ul {
          padding: 6px 32px 6px 16px;
          & li > a {
            display: block;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            color: var(--colGray5);
            padding: 10px 0;
          }
          & li.on a {
            color: var(--colBlack);
            font-weight: 600;
          }
        }
      }
    }
  }
  & > li::after {
    content: '';
    position: absolute;
    top: calc(50% - (14px / 2));
    right: 0;
    width: 1px;
    height: 14px;
    background: var(--colGray3);
  }
  & > li:last-child {
    padding-left: 12px;
  }
  & > li:last-child::after {
    display: none;
  }
`

// 상품목록 영역 wrap
export const ProductWrap = styled.div<{ listType: string }>`
  font-size: 14px;
  display: grid;
  grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)')};
  grid-gap: ${(props) => (props.listType === 'thumb' ? '30px 12px' : '16px')};

  @media screen and (min-width: 768px) {
    grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)')};
    grid-gap: 48px 16px;
    margin-bottom: 84px;
  }
`
